<template>
  <div>
    <!-- <modal-pdf title="會員合約" :pdf-url="signPDFUrl" /> -->

    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->

        <div
          class="d-flex flex-wrap justify-content-between flex-lg-nowrap align-items-center"
        >
          <div class="d-flex">
            <h3
              class="d-flex align-items-center font-weight-bolder text-nowrap mb-0"
            >
              <feather-icon class="mr-50" size="18" icon="FileTextIcon" />
              續費/加購額度記錄
            </h3>
            <div class="form-col-select ml-2">
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block"
              />
              <feather-icon size="18" icon="ChevronDownIcon" />
            </div>
            <div class="search-primary ml-2">
              <feather-icon size="16" icon="SearchIcon" />
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="搜尋..."
              />
            </div>
          </div>
        </div>
      </div>
      <b-table
        ref="refMembershipLogsListTable"
        class="position-relative"
        :items="fetchMembershipLogs"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="未找到匹配的記錄"
        :sort-desc.sync="isSortDirDesc"
      >

        <template #cell(created_at)="data"> 
          {{ getCorrectDateTime(data.item.created_at) }}
        </template>
        <!-- <template #cell(actions)="data">
          <b-dropdown
            :class="`action-trigger-btn ${
              approvesList.length <= 3 ? 'hor' : 'ver'
            }`"
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="EyeIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>


          </b-dropdown>
        </template> -->
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >在{{ dataMeta.of }}個記錄中，正在顯示 {{ dataMeta.from }} 至
              {{ dataMeta.to }}個記錄</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalMembershipLogs"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>
      
  <script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import useMembershipLogsList from "./useMembershipLogsList";
import memberStoreModule from "../memberStoreModule";
import ModalPdf from "@/layouts/components/file/ModalPdf.vue";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    vSelect,
    ModalPdf,
  },
  data() {
    return {
    };
  },
  methods: {
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "app-member";
    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, memberStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });



    const {
      fetchMembershipLogs,
      tableColumns,
      perPage,
      currentPage,
      totalMembershipLogs,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refMembershipLogsListTable,
      refetchData,
      membershipLogsList,
      ability,
    } = useMembershipLogsList();

    return {
      fetchMembershipLogs,
      tableColumns,
      perPage,
      currentPage,
      totalMembershipLogs,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refMembershipLogsListTable,
      refetchData,
      membershipLogsList,
      ability,
    };
  },
};
</script>
      
  <style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.search-primary {
  width: calc(100% - 500px);
}
.top-button-list {
  // width: 500px;
  margin: 0;
  .btn {
    width: 150px;
    margin: 0 auto;
    display: block;
  }
}
@media screen and (max-width: 991px) {
  .search-primary {
    width: calc(100% - 220px);
  }
  .top-button-list {
    margin-left: auto;
    margin-right: 20px;
    .btn {
      width: 150px;
      margin: 0 auto;
      display: block;
    }
  }
}

@media screen and (max-width: 768px) {
  .search-primary {
    width: 100%;
  }
}
@media screen and (max-width: 575px) {
  .top-button-list {
    margin: 0;
    width: 100%;
  }
}
</style>
      
  <style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@/assets/scss/variables/_variables.scss";
</style>
      